"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const expo_blur_1 = require("expo-blur");
const WIDGET_BORDER_PROPORTION = 0.4;
function Widget(_a) {
    var { children, size = 30, blurred = true } = _a, props = __rest(_a, ["children", "size", "blurred"]);
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const { style } = props, rest = __rest(props, ["style"]);
    const customStyle = [
        {
            flexDirection: 'row',
            padding: normalize(0.3 * size),
            borderRadius: normalize(WIDGET_BORDER_PROPORTION * size),
            borderWidth: normalize(Math.max(1, size / 15)),
            borderColor: currentTheme.currentPalette.c100
        },
        style
    ];
    return (blurred ?
        (react_1.default.createElement(expo_blur_1.BlurView, Object.assign({ intensity: 60, tint: currentTheme.mode, style: customStyle }, rest), children))
        : (react_1.default.createElement(react_native_1.View, Object.assign({ style: customStyle }, rest), children)));
}
exports.Widget = Widget;
//# sourceMappingURL=widget.js.map